import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';

import { TypeCPVClassComponent } from './typeCPVClass/typeCPV-class.component';
import { TypeNatureMarcheChoixComponent } from './typeNatureMarcheChoix/type-nature-marche-choix.component';
import { TypeFNSSimpleDescMarcheComponent } from './typeFNSSimpleDescMarche/typeFNS-simple-desc-marche.component';
import { OuiComponent } from './oui/oui.component';
import { TypeObjCPVComponent } from './typeObjCPV/type-objCPV.component';
import { CommunicationFNSSimpleComponent } from './communicationFNSSimple/communicationFNS-simple.component';
import { TypeOuiNonNbCandidatReduitFNSSimpleComponent } from './typeOuiNonNbCandidatReduitFNSSimple/type-oui-non-nb-candidat-reduitFNS-simple.component';
import { PresOffresFNSComponent } from './presOffresFNS/pres-offresFNS.component';
import { TypeLotsFNSSimpleComponent } from './typeLotsFNSSimple/type-lotsFNS-simple.component';
import { NonComponent } from './non/non.component';
import { LotComponent } from './lot/lot.component';
import { TypeMontantComponent } from './typeMontant/type-montant.component';
import { UrlSecuriteComponent } from './urlSecurite/url-securite.component';
import { TypeOuiNonReservationMarcheComponent } from './typeOuiNonReservationMarche/type-oui-non-reservation-marche.component';
import { TechAchatFNSComponent } from './techAchatFNS/tech-achatFNS.component';
import { TypeOuiNonInformComplementaireComponent } from './typeOuiNonInformComplementaire/type-oui-non-inform-complementaire.component';
import { TypeProcFNSComponent } from './typeProcFNS/type-procFNS.component';
import { TypeOuiNonComponent } from './typeOuiNon/type-oui-non.component';
import { DocSecuriteComponent } from './docSecurite/doc-securite.component';
import { InitialComponent } from './initial/initial.component';
import { TypeMarcheReserveComponent } from './typeMarcheReserve/type-marche-reserve.component';
import { FormfnsComponent } from './formfns/formfns.component';
import { OuiTypeOuiNonReservationMarcheComponent } from './ouiTypeOuiNonReservationMarche/oui-type-oui-non-reservation-marche.component';
import { OuiTypeOuiNonNbCandidatReduitFNSSimpleComponent } from './ouiTypeOuiNonNbCandidatReduitFNSSimple/oui-type-oui-non-nb-candidat-reduitFNS-simple.component';
import { OuiTypeOuiNonInformComplementaireComponent } from './ouiTypeOuiNonInformComplementaire/oui-type-oui-non-inform-complementaire.component';
import { Step1Component } from './steps/step1/step1.component';
import { Step2Component } from './steps/step2/step2.component';
import { Step3Component } from './steps/step3/step3.component';
import { Step4Component } from './steps/step4/step4.component';
import { Step5Component } from './steps/step5/step5.component';
import { FormfnsimpleCommonModule } from '../common/formfns.module';
import { TypeMontantFourchetteComponent } from './typeMontantFourchette/type-montant-fourchette.component';
import { FourchetteComponent } from './fourchette/fourchette.component';


@NgModule({
	declarations: [
		TypeMontantFourchetteComponent,
		FourchetteComponent,
		TypeCPVClassComponent,
		TypeNatureMarcheChoixComponent,
		TypeFNSSimpleDescMarcheComponent,
		OuiComponent,
		TypeObjCPVComponent,
		CommunicationFNSSimpleComponent,
		TypeOuiNonNbCandidatReduitFNSSimpleComponent,
		PresOffresFNSComponent,
		TypeLotsFNSSimpleComponent,
		NonComponent,
		LotComponent,
		TypeMontantComponent,
		UrlSecuriteComponent,
		TypeOuiNonReservationMarcheComponent,
		TechAchatFNSComponent,
		TypeOuiNonInformComplementaireComponent,
		TypeProcFNSComponent,
		TypeOuiNonComponent,
		DocSecuriteComponent,
		InitialComponent,
		TypeMarcheReserveComponent,
		FormfnsComponent,
		OuiTypeOuiNonNbCandidatReduitFNSSimpleComponent,
		OuiTypeOuiNonInformComplementaireComponent,
		OuiTypeOuiNonReservationMarcheComponent,
		Step1Component,
		Step2Component,
		Step3Component,
		Step4Component,
		Step5Component,
	],
	exports: [FormfnsComponent],
	imports: [CommonModule, ReactiveFormsModule, SharedModule, FormfnsimpleCommonModule],
})
export class FormfnsModule {}
